import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";
import { Link } from "react-router-dom";

const NotFoundNews = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <h1>{t("news.notFound")}</h1>
            <Link to="/news" title={t("news.showNews")}>
                {t("news.showNews")}
            </Link>
        </div>
    );
};

export default NotFoundNews;
